export default (function () {
  $(".estate__item").each(function (i) {
    $(this).find(".table__item").each(function (i) {
      i = i + 1;
      $(this).on("click", function (e) {
        console.log(e.target);
        $('.table__item').removeClass('active');
        if (!$(this).hasClass('active')) {
          $(this).addClass('active');
        }
        if ($(this).parents('.estate__item').find('*[data-number="' + i + '"]').length) {
          $(this).parents('.estate__item').find('.estate__item-image img').hide();
          $(this).parents('.estate__item').find('*[data-number="' + i + '"]').show();
        }
      });
    });
  });
  $(document).mouseup(function (e) {
    $(".estate__item").each(function (i) {
      var container = $(this).find(".table");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.table__item').removeClass('active');
        $(this).find('.estate__item-image img').hide();
        $(this).find('.estate__item-image img').first().show();
      }
    });
  });
});